import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { timeout } from 'rxjs/operators';
import { CommonFunctions } from 'src/app/Utilities/CommonFunctions';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeatureService {
  constructor(private http: HttpClient) {}

  private getHeaders() {
    const TOKEN = CommonFunctions.getToken();
    return new HttpHeaders({
      Authorization: 'Bearer ' + TOKEN,
      'Content-Type': 'application/json'
    });
  }

  listFeatures() {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/feature/list';
    return this.http.get(url, { headers: this.getHeaders() }).pipe(timeout(60000));
  }

  addFeature(feature: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/feature';
    return this.http.post(url, { data: feature }, { headers: this.getHeaders() }).pipe(timeout(60000));
  }

  editFeature(feature: any, id: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/feature/' + id;
    return this.http.put(url, { data: feature }, { headers: this.getHeaders() }).pipe(timeout(60000));
  }

  removeFeature(id: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/feature/' + id;
    return this.http.delete(url, { headers: this.getHeaders() }).pipe(timeout(60000));
  }
}
